import { Injectable } from '@angular/core';
import { Asset } from '../model/itsm';

@Injectable({
  providedIn: 'root'
})
export class DataShareService {

  appGroups: [];

  services: [] = [];
  assets: Asset[] = [];
  constructor() { }
}
